import { useEffect } from 'react';
import { useStore, useStoreApi } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { usePageConfig } from '@tmsw/powerups.config.page.provider';
import { SrOnly } from '@tmsw/powerups.ui.a11y.sr-only';

const defaultLocaleKey = 'pageTitle';
const defaultParentNode = 'GENERAL';

export function PageTitleAnnouncer() {
  const { subscribe } = useStoreApi();
  const { __t } = useTranslation();
  const defaultPageTitle = __t(defaultLocaleKey, defaultParentNode);
  const pageTitle = useStore((state) => state.pageTitle);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const inPortrait = useStore((state) => state.inPortrait);
  const isPauseMenuDisplayed = useStore((state) => state.isPauseMenuDisplayed);
  const showA11yMenu = useStore((state) => state.showA11yMenu);
  const currentPage = useStore((state) => state.currentPage);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);

  const { getPageKey } = usePageConfig();

  useEffect(() => {
    const unsub = subscribe(
      (state: any) => state.pageTitle,
      (newPageTitle: string) => {
        document.title = newPageTitle || defaultPageTitle;
      }
    );
    return () => {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscribe]);

  useEffect(() => {
    let parentNode = defaultParentNode;
    const intlKey = defaultLocaleKey;
    const pageKey = getPageKey(currentPage);
    const pageHasTitle = __t(defaultLocaleKey, pageKey);
    if (pageHasTitle && pageKey !== null) {
      parentNode = pageKey;
    }
    if (!showA11yMenu && !isPauseMenuDisplayed && !showSettingsPanel) {
      setPageTitle(__t(intlKey, parentNode));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, showA11yMenu, showSettingsPanel, isPauseMenuDisplayed]);

  return (
    <SrOnly role="alert" aria-live="polite" aria-atomic="true" tabIndex={-1}>
      {pageTitle || defaultPageTitle}
    </SrOnly>
  );
}
